import { GameEvents as SharedGameEvents, TANK_SKINS as SharedTankSkins } from './shared/constants';

export const GameEvents = SharedGameEvents;
export const TANK_SKINS = SharedTankSkins;

export const SOCKET_EVENTS = {
  PLAYER_JOIN: 'player:join',
  PLAYER_LEAVE: 'player:leave',
  PLAYER_UPDATE: 'player:update',
  PLAYERS_REQUEST: 'players:request',
  PLAYERS_UPDATE: 'players:update',
  ROOM_CREATE: 'room:create',
  ROOM_JOIN: 'room:join',
  ROOM_LEAVE: 'room:leave',
  ROOM_CREATED: 'room:created',
  ROOM_JOINED: 'room:joined',
  ROOMS_REQUEST: 'rooms:request',
  ROOMS_UPDATE: 'rooms:update',
  CHAT_MESSAGE: 'chat:message',
} as const;

